<section [ngClass]="skin.whiteLabel">
    <ng-container *ngIf="!isShowCongratulations">

        <h1 class="title">{{ 'QUICK_ACTIVATION' | translate }}</h1>

        <div class="stepper">
            <div class="item" [ngClass]="{active: !isShowPlansInfo}">
                <span>1</span>
                {{'activateDevice' | translate}}
            </div>

            <div class="line"></div>

            <div class="item" [ngClass]="{active: isShowPlansInfo}">
                <span>2</span>
                {{'SUBSCRIBE' | translate}}
            </div>
        </div>
    </ng-container>


    <ng-container *ngIf="!isShowCongratulations">
        <ng-container *ngIf="!isShowPlansInfo">
            <p class="description">
                {{ 'QUICK_ACTIVATION_MSG' | translate: {skin: skin.brandName} }}
            </p>

            <form [formGroup]="quickActivationForm" (ngSubmit)="onSubmit(quickActivationForm.valid)">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>{{ 'EMAIL' | translate }}</mat-label>
                    <input matInput required placeholder="{{ 'EMAIL' | translate }}" formControlName="email" />
                </mat-form-field>


                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>{{ 'TRACKER_ID' | translate }}</mat-label>
                    <input matInput required placeholder="{{ 'TRACKER_ID' | translate }}" formControlName="trackerID" />
                </mat-form-field>


                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>{{ 'LAST_4_DIGITS_OF_TRACKER_IMEI' | translate }}*</mat-label>
                    <input type="text" placeholder="{{ 'IMEI' | translate }}" formControlName="IMEI" matInput />
                </mat-form-field>

                <div class="device-info">
                    <div class="info-toggler" (click)="toggleInfo()">
                        {{'WHERE_IMEI' | translate}}
                        <i class="icon" [ngClass]="{bottom: !isShowDeviceInfo}" [inlineSVG]="'#chevron-top-white'"></i>
                    </div>

                    <div class="info" *ngIf="isShowDeviceInfo">
                        <div>
                            <div class="item">1. {{'ON_DEVICE_BOX' | translate}}</div>
                            <div class="item">2. {{'BACK_ON_DEVICE' | translate}}</div>
                            <div class="item">3. {{'UNDER_THE_BATTERY' | translate}}</div>
                        </div>

                        <img src="assets/images/device-details.svg" alt="zone-type">
                    </div>
                </div>

                <button class="btn primary form-btn" type="submit" mat-flat-button>
                    {{ 'ACTIVATE' | translate }}
                </button>
            </form>

        </ng-container>

        <ng-container *ngIf="isShowPlansInfo">
            <p class="description">
                {{ 'QUICK_ACTIVATION_MSG_2' | translate }}
            </p>

            <div class="plans">
                <div class="plan" *ngFor="let planDTO of planDTOList" (click)="selectPlan(planDTO)"
                    [ngClass]="{active: slectedPlan?.id === planDTO.id}">
                    <div class="best" *ngIf="planDTO.clubPromotion">
                        {{'BEST_OFFER' | translate}}
                    </div>
                    <div class="plan-title">
                        <div class="name">
                            <span class="checkbox"><i class="icon"
                                    [inlineSVG]="'#check-success-white'"></i></span>{{planDTO.name}}
                        </div>
                        <div class="price">${{planDTO.amount}} p/{{planDTO.paymentCycle === 'YEAR' ? 'y' : 'm'}}
                        </div>
                    </div>
                    <div class="info">
                        <p>{{planDTO.comments}}</p>
                    </div>
                </div>
            </div>

            <button class="btn primary form-btn" (click)="onSubscribe()" mat-flat-button>
                {{ 'SUBSCRIBE' | translate }}
            </button>
        </ng-container>
    </ng-container>


    <ng-container *ngIf="isShowCongratulations">
        <h1 class="title">{{ 'CONGRATULATIONS' | translate }}</h1>

        <p class="description">
            {{ 'CONGRATULATIONS_MSG' | translate }}
        </p>

        <div class="congratulations-info">
            <h2>{{'TIME_TO_POWER_DEVICE' | translate}}</h2>

            <img src="assets/images/pet-loc-dev.png" alt="Pet Loc8 device">

            <p>{{'CONGRATULATIONS_MSG_2' | translate}}
            </p>
        </div>

        <button class="btn primary form-btn" (click)="goToLogin()" mat-flat-button>
            {{ 'OPEN_SKIN_APP' | translate: {skin: skin.brandName} }}
        </button>
    </ng-container>
</section>